<template>
  <div class="app-content">
    <div class="p-main">
        <div class="standard">
          <div class="standard-search">
            <div class="search">
              <input placeholder="请输入搜索内容" v-model="queryParams.searchKey" @keyup.enter="searchList" class="search-input" />
              <div class="search-btn" @click="searchList">搜索</div>
            </div>
          </div>
          <div class="standard-list" v-if="list.length" ref="scrollRef">
            <van-list finished-text="- 已没有更多汇篇 -" error-text="- 请求失败，点击重新加载 -" :immediate-check="false" :error.sync="errorFlag" :finished="finished" @load="getMoreList">
              <div class="standard-item" v-for="item in list" :key="item.id" @click="toInfo(item)">
                <div class="standard-item-title">
                  {{ item.title }}
                </div>
                <div class="standard-item-time">
                  发布时间：{{ item.createTime ? item.createTime.substring(0, 10) : '-' }}
                </div>
              </div>
            </van-list>

          </div>
          <div class="standard-list" v-else>
            <van-empty description="暂无汇篇"></van-empty>
          </div>
        </div>
    </div>

  </div>
</template>

<script>
import service from '@/api/service'

export default {
  name: "standard-index",
  data () {
    return {
      queryParams: {
        searchKey: '',
        pageSize: 10,
        pageNum: 1
      },
      list: [],
      total: 0,
      finished: false,
      errorFlag: false,
      listLoading: false
    }
  },
  mounted() {
    this.finished = false
    this.getList()
  },
  methods: {
    searchList () {
      this.finished = false
      this.queryParams.pageNum = 1
      if (this.$refs.scrollRef) this.$refs.scrollRef.scrollTop= 0
      this.getList()
    },
    getMoreList () {
      if (this.list.length < this.total) {
        this.finished = false
        this.queryParams.pageNum += 1
        this.getList()
        return
      }
      this.finished = true
    },
    getList () {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      service.fetchStandardList({
        pageSize: this.queryParams.pageSize,
        pageNum: this.queryParams.pageNum,
        title: this.queryParams.searchKey,
        publicStatus: "1"
      })
        .then(res => {
          this.total = res.data.total
          this.list = this.queryParams.pageNum === 1 ? res.data.records : this.list.concat(res.data.records)
          this.errorFlag = false
          this.$toast.clear()
        })
        .catch(() => {
          this.errorFlag = true
          this.$toast.clear()
        })
    },
    toInfo (item) {
      this.$router.push({
        path: '/standard-info',
        query: {
          id: item.id
        }
      })
    }
  }
}
</script>

<style scoped>
.standard {
  display: flex;
  flex-direction: column;
  padding: 15px 10px 0 10px;
  box-sizing: border-box;
}
.standard-search {
  display: flex;
  flex-direction: row;
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 10px;
}
.search {
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
}
.search input:focus {
  outline: none;
}
.search-input {
  flex: 1;
  background: none;
  border: none;
  border-radius: 8px 0 0 8px;
  height: 40px;
  font-size: 14px;
  padding: 0 15px;
  box-sizing: border-box;
}
.search-btn {
  width: 60px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 0 8px 8px 0;
  font-size: 15px;
  color: #35A87D;
  border-left: 1px solid #35A87D;
}
.standard-list {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 65px);
  overflow-y: auto;
  overflow-x: hidden;
}
.no-more {
  width: 100%;
  font-size: 14px;
  color: #666666;
  text-align: center;
  padding: 5px 0;
}
.standard-item {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
}
.standard-item-title {
  font-size: 18px;
  color: #35A87D;
  margin-bottom: 5px;
}
.standard-item-time {
  font-size: 14px;
  color: #444;
}
</style>